export default __webpack_public_path__ + "static/media/guifos.842788b4.png";